'use strict';

var cssKey = require('./css-key');

module.exports = function getCss(csjs) {
  return csjs[cssKey];
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/lib/get-css.js
 ** module id = 24
 ** module chunks = 0
 **/